// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Main container */
.cae-analysis-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 80px;
  background-color: #fff; /* Set background to white */
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  gap: 20px;
}

/* Left Section - Content */
.cae-analysis-text {
  width: 60%;
  order: 1; /* Place content on the left */
  margin-top: -30px;
}

.cae-analysis-text h1 {
  font-size: 2em;
  color: #000;
  margin-bottom: 10px;
}

.cae-analysis-text h2 {
  font-size: 1.5em !important;
  color: #555;
  margin-bottom: 5px !important;
}

.cae-analysis-text p {
  font-size: 1em;
  color: #555;
  margin-bottom: 10px;
}

.services-list {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  list-style: none;
  padding: 0;
}

.services-list li {
  width: 45%;
  font-size: 0.9em;
  color: #333;
}

/* Right Section - Image */
.cae-analysis-image {
  position: relative;
  width: 32%;
  order: 2; /* Place image on the right */
  margin-top: 60px;
}

.services-image {
  width: 100%;
  height: auto;
  border-radius: 8px;

}

/* Button */
.cae-analysis-button {
  background-color: #00c853;
  color: white;
  border: none;
  padding: 10px 20px;
  font-size: 1em;
  border-radius: 4px;
  cursor: pointer;
  margin-top: 20px;
  transition: background-color 0.3s ease;
}

.cae-analysis-button:hover {
  background-color: #009624;
}

/* Responsive Design */
@media (max-width: 768px) {
  .cae-analysis-container {
    flex-direction: column; /* Stack items for smaller screens */
    align-items: center;
    text-align: left;
    gap: 20px;
  }

  .cae-analysis-text {
    width: 145%;
    order: 1; /* Maintain order for responsive layout */
  }

  

  .services-list li {
    width: 100%;
  }
  /* Right Section - Image */
.cae-analysis-image {
  position: relative;
  width: 150%;
  margin-top:70px;
  order: 1; /* Place image on the right */
}

.services-image {
  width: 100%;
  height: auto;
  border-radius: 8px;
}
}


/* For 1920x1080 screen size */
@media (min-width: 1920px) and (max-width: 1920px) {
  .cae-analysis-container {
    padding: 100px; /* Increase padding for larger screens */
  }

  .cae-analysis-text {
    width: 58%; /* Adjust width for content */
  }

  .cae-analysis-image {
    width: 38%; /* Adjust image width */
  }

  .services-list li {
    width: 40%; /* Adjust list item width */
  }
}

/* For screens between 1380px and 1919px */
@media (min-width: 1380px) and (max-width: 1919px) {
  .cae-analysis-container {
    padding: 80px; /* Adjust padding */
  }

  .cae-analysis-text {
    width: 59%; /* Adjust content width */
  }

  .cae-analysis-image {
    width: 28%; /* Adjust image width */
  }

  .services-list li {
    width: 44%; /* Adjust list item width */
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/CAEAnalysis/CAEAnalysis.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,aAAa;EACb,sBAAsB,EAAE,4BAA4B;EACpD,kBAAkB;EAClB,wCAAwC;EACxC,SAAS;AACX;;AAEA,2BAA2B;AAC3B;EACE,UAAU;EACV,QAAQ,EAAE,8BAA8B;EACxC,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,WAAW;EACX,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,WAAW;AACb;;AAEA,0BAA0B;AAC1B;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ,EAAE,6BAA6B;EACvC,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;;AAEpB;;AAEA,WAAW;AACX;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,sBAAsB;AACtB;EACE;IACE,sBAAsB,EAAE,oCAAoC;IAC5D,mBAAmB;IACnB,gBAAgB;IAChB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,QAAQ,EAAE,yCAAyC;EACrD;;;;EAIA;IACE,WAAW;EACb;EACA,0BAA0B;AAC5B;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,QAAQ,EAAE,6BAA6B;AACzC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;AACA;;;AAGA,8BAA8B;AAC9B;EACE;IACE,cAAc,EAAE,wCAAwC;EAC1D;;EAEA;IACE,UAAU,EAAE,6BAA6B;EAC3C;;EAEA;IACE,UAAU,EAAE,uBAAuB;EACrC;;EAEA;IACE,UAAU,EAAE,2BAA2B;EACzC;AACF;;AAEA,0CAA0C;AAC1C;EACE;IACE,aAAa,EAAE,mBAAmB;EACpC;;EAEA;IACE,UAAU,EAAE,yBAAyB;EACvC;;EAEA;IACE,UAAU,EAAE,uBAAuB;EACrC;;EAEA;IACE,UAAU,EAAE,2BAA2B;EACzC;AACF","sourcesContent":["/* Main container */\n.cae-analysis-container {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 80px;\n  background-color: #fff; /* Set background to white */\n  border-radius: 8px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  gap: 20px;\n}\n\n/* Left Section - Content */\n.cae-analysis-text {\n  width: 60%;\n  order: 1; /* Place content on the left */\n  margin-top: -30px;\n}\n\n.cae-analysis-text h1 {\n  font-size: 2em;\n  color: #000;\n  margin-bottom: 10px;\n}\n\n.cae-analysis-text h2 {\n  font-size: 1.5em !important;\n  color: #555;\n  margin-bottom: 5px !important;\n}\n\n.cae-analysis-text p {\n  font-size: 1em;\n  color: #555;\n  margin-bottom: 10px;\n}\n\n.services-list {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  list-style: none;\n  padding: 0;\n}\n\n.services-list li {\n  width: 45%;\n  font-size: 0.9em;\n  color: #333;\n}\n\n/* Right Section - Image */\n.cae-analysis-image {\n  position: relative;\n  width: 32%;\n  order: 2; /* Place image on the right */\n  margin-top: 60px;\n}\n\n.services-image {\n  width: 100%;\n  height: auto;\n  border-radius: 8px;\n\n}\n\n/* Button */\n.cae-analysis-button {\n  background-color: #00c853;\n  color: white;\n  border: none;\n  padding: 10px 20px;\n  font-size: 1em;\n  border-radius: 4px;\n  cursor: pointer;\n  margin-top: 20px;\n  transition: background-color 0.3s ease;\n}\n\n.cae-analysis-button:hover {\n  background-color: #009624;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .cae-analysis-container {\n    flex-direction: column; /* Stack items for smaller screens */\n    align-items: center;\n    text-align: left;\n    gap: 20px;\n  }\n\n  .cae-analysis-text {\n    width: 145%;\n    order: 1; /* Maintain order for responsive layout */\n  }\n\n  \n\n  .services-list li {\n    width: 100%;\n  }\n  /* Right Section - Image */\n.cae-analysis-image {\n  position: relative;\n  width: 150%;\n  margin-top:70px;\n  order: 1; /* Place image on the right */\n}\n\n.services-image {\n  width: 100%;\n  height: auto;\n  border-radius: 8px;\n}\n}\n\n\n/* For 1920x1080 screen size */\n@media (min-width: 1920px) and (max-width: 1920px) {\n  .cae-analysis-container {\n    padding: 100px; /* Increase padding for larger screens */\n  }\n\n  .cae-analysis-text {\n    width: 58%; /* Adjust width for content */\n  }\n\n  .cae-analysis-image {\n    width: 38%; /* Adjust image width */\n  }\n\n  .services-list li {\n    width: 40%; /* Adjust list item width */\n  }\n}\n\n/* For screens between 1380px and 1919px */\n@media (min-width: 1380px) and (max-width: 1919px) {\n  .cae-analysis-container {\n    padding: 80px; /* Adjust padding */\n  }\n\n  .cae-analysis-text {\n    width: 59%; /* Adjust content width */\n  }\n\n  .cae-analysis-image {\n    width: 28%; /* Adjust image width */\n  }\n\n  .services-list li {\n    width: 44%; /* Adjust list item width */\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
